const ComponentSeasonIdentifiers = {
    BASE: 'Base',
    GAMES: 'Games',
    TEAMS: 'Teams',
    STATS: 'Stats'
};


export default ComponentSeasonIdentifiers;
